import { useState, useEffect } from "react";
import { useGerenciamento } from "../Context/GerenciamentoContext";
import { Link, useNavigate } from 'react-router-dom';
import "../../App.css";
import "./Forms.css";

import faltaIcon from "../../assets/icons/falta.png";

import AgendamentosService from "../../services/AgendamentosService";
import FaltasService from "../../services/FaltasService";
import formFaltaDTO from "../../types/FormFaltaDTO";

export default function FaltasForm({ itemSelecionado, modo, onClose }) {
  const [form, setForm] = useState({
    idFalta: null,
    data: "",
    idHorario: "",
    horario: "",
    idCadastro: "",
    nome: "",
    idAgendamento: "",
    pago: null,
    valorPagto: "",
    reembolsado: null,
    valorReembolso: "", 
    ativo: ""
  });

  const [historico, setHistorico] = useState([]);
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const { setRetorno } = useGerenciamento();

  // ==========================
  // LOAD MODO
  // ==========================
  useEffect(() => {
    if (modo === "novo") {
      setForm({
        idFalta: null,
        data: "",
        idHorario: "",
        horario: "",
        idCadastro: "",
        nome: "",
        idAgendamento: "",
        pago: null,
        valorPagto: "",
        reembolsado: null,
        valorReembolso: "", 
        ativo: ""
      });
    }

    if (modo === "alterar" && itemSelecionado) {
      setForm({
        idFalta: itemSelecionado.IDFALTA,
        data: itemSelecionado.DATA || "",
        idHorario: String(itemSelecionado.IDHORARIO),
        horario: itemSelecionado.HORARIO || "",
        idCadastro: String(itemSelecionado.IDCADASTRO),
        nome: String(itemSelecionado.NOME) || "",
        idAgendamento: String(itemSelecionado.IDAGENDAMENTO),
        pago: Boolean(itemSelecionado.PAGO),
        valorPagto: itemSelecionado.valor_pagto ?? "",
        reembolsado: Boolean(itemSelecionado.REEMBOLSADO),
        valorReembolso: itemSelecionado.valor_reembolso  ?? "", 
        ativo: itemSelecionado.ativo
      });
    }
  }, [modo, itemSelecionado]);

  // ==========================
  // HISTÓRICO
  // ==========================
  useEffect(() => {
    async function carregar() {
      const hist = await AgendamentosService.getNaoRealizados();
      setHistorico(hist);
    }
    carregar();
  }, []);

  // ==========================
  // SELECT AGENDAMENTO
  // ==========================
  function handleSelectAgendamento(e) {
    const id = Number(e.target.value);

    if (!id) {
      setForm(prev => ({
        ...prev,
        idAgendamento: "",
        data: "",
        horario: "",
        idHorario: "",
        idCadastro: "",
        nome: "",
        pago: null,
        valorPagto: "",
        reembolsado: null,
        valorReembolso: "", 
        ativo: ""
      }));
      return;
    }

    const ag = historico.find(a => a.IDAGENDAMENTO  === id);
    if (!ag) return;

    setForm(prev => ({
      ...prev,
      idAgendamento: ag.IDAGENDAMENTO,
      data: ag.DATA,
      horario: ag.HORARIO,
      idHorario: ag.IDHORARIO,
      idCadastro: ag.IDCADASTRO,
      nome: ag.NOME,
      pago: ag.PAGO ?? false,
      valorPagto: ag.valor_pagto ?? "",
      reembolsado: ag.REEMBOLSADO ?? false,
      valorReembolso: ag.valor_reembolso ?? "", 
      ativo: ag.ATIVO
    }));
  }

  // ==========================
  // HANDLERS
  // ==========================

    function handleChange(e) {
    const { name, value } = e.target;

    if (name === "ativo") {
      setForm(prev => ({
        ...prev,
        ativo: value === "true"
      }));
      return;
    }

    setForm(prev => ({
      ...prev,
      [name]: value
    }));
  }


  // ==========================
  // VALIDATION
  // ==========================
  function validarCampos() {
    const e = {};
    if (!form.idAgendamento) e.IDAGENDAMENTO = "Informe o agendamento";
    return e;
  }

  // ==========================
  // SUBMIT
  // ==========================
  async function handleSubmit(e) {
    e.preventDefault();

    const validation = validarCampos();
    setErrors(validation);
    if (Object.keys(validation).length) return;

    setLoading(true);
      try {
        if (modo === "novo") {
          
          await FaltasService.create(form.idAgendamento);
          setRetorno({ tipo: "sucesso", mensagem: "Falta registrada com sucesso!" });
        } 
        
        if(modo === "alterar") {
          const payload_update = {
            IDFALTA: Number(form.idFalta)
          };
          await FaltasService.update(form.idFalta, payload_update);
          setRetorno({ tipo: "sucesso", mensagem: "Falta atualizada com sucesso!" });
        }
      onClose();
    } catch {
      setRetorno({
        tipo: "erro",
        mensagem: modo === "novo"
          ? "Erro ao registrar falta."
          : "Erro ao atualizar falta."
      });
      onClose();
    } finally {
      setLoading(false);
    }
  }

  // ==========================
  // RENDER
  // ==========================
  return (
    <div className="Form-Interno-Container">
      <form onSubmit={handleSubmit}>
        <div className="Form-Interno-title">
          <img src={faltaIcon} alt="" className="icon" />
          {modo === "novo" ? "Registrar Falta" : "Alterar Falta"}
        </div>

        <div className="Form-Interno-linha" />

        <div className="Form-Interno-alinhamento">
          <div className="Form-Interno-label">Agendamento: *</div>
          <select value={form.idAgendamento } onChange={handleSelectAgendamento}>
            <option value="">Selecione</option>
            {historico.map(ag => (
              <option key={ag.IDAGENDAMENTO} value={ag.IDAGENDAMENTO}>
                {ag.DATA} - {ag.HORARIO.slice(0, 5)} - {ag.DESCRICAO} - {ag.NOME}
              </option> 
            ))}
          </select>
          {errors.IDAGENDAMENTO && (
            <span className="erro">{errors.IDAGENDAMENTO}</span>
          )}
        </div>

        <div className="Form-Interno-alinhamento">
          <div className="Form-Interno-label">Data</div>
          <input type="text" value={form.data} disabled />
        </div>

        <div className="Form-Interno-alinhamento">
          <div className="Form-Interno-label">Horário</div>
          <input type="text"  value={form.horario ? `${form.horario.slice(0, 5)} h` : ""} disabled /> 
        </div>

        <div className="Form-Interno-alinhamento">
          <div className="Form-Interno-label">Cadastro</div>
          <input type="text" value={form.nome} disabled />
        </div>

        <div className="Form-Interno-alinhamento">
          <div className="Form-Interno-label">Pago?</div>
          <input type="text"   
            value={ form.pago === null || form.pago === undefined
                ? ""
                : form.pago
                ? "Sim"
                : "Não"
            } disabled />
        </div>

        <div className="Form-Interno-alinhamento">
          <div className="Form-Interno-label">Valor Pago</div>
          <input type="text" value={form.valorPagto} disabled />
        </div>

        <div className="Form-Interno-alinhamento">
          <div className="Form-Interno-label">Reembolsado?</div>
          <input type="text" 
            value={
                form.reembolsado === null || form.reembolsado === undefined
                ? ""
                : form.reembolsado
                ? "Sim"
                : "Não"
            } disabled />
        </div>

        <div className="Form-Interno-alinhamento">
          <div className="Form-Interno-label">Valor Reembolso</div>
          <input type="text" value={form.valorReembolso} disabled />
        </div>

        {modo === "alterar" && (
          <div className="Form-Interno-alinhamento">
            <div className="Form-Interno-label">Contabilizar falta?</div>
            <select
              name="ativo"
              value={String(form.ativo)}
              onChange={handleChange}
            >
              <option selected value="">Selecione</option>
              <option value="true">Sim</option>
              <option value="false">Não</option>
            </select>
          </div>
        )}

        <div className="Form-Interno-alinhamento-button">
          <button type="submit" disabled={loading} className="Form-Interno-button">
            {loading ? "Enviando..." : "Salvar"}
          </button>
          
          <button type="button" className="Form-Interno-button" onClick={onClose}>
            Voltar
          </button>
        </div>
      </form>
    </div>
  );
}
